import { ContentType, ContentTypeGroup } from '@src/__generated__/types';
import { EditNodeFormValues } from '@src/assets/types/hierarchies/Hierarchies.types';

import { isMultiLangField, isTranslatableField } from '../form/shared';

export interface IGetSourceFieldContent {
    fieldContext: string;
    valueContext: string;
    measureFieldContext: string;
    getToggleTranslationName: (uniqueId: string) => string;
}

function getSourceFieldContent(
    group: ContentTypeGroup['code'],
    ct: ContentType | EditNodeFormValues,
    prefix = '',
): IGetSourceFieldContent {
    const placeholder = '$$$position';
    const fieldContext = prefix || `${group}.${ct?.code}`;

    const position = !ct?.multiLanguage || ct.type === 'select' ? '0' : placeholder;
    const multiValuePosition =
        ['dateRange', 'link'].includes(ct.type) || ct?.multiValue ? '' : '.0';
    const valuePlaceholder = '$$$value';
    const value =
        isTranslatableField(ct.type) && isMultiLangField(ct.type) && ct.multiLanguage
            ? valuePlaceholder
            : 'value';
    const valueContext = `${fieldContext}.value.${position}.${value}${multiValuePosition}`;

    const measureFieldContext = `${fieldContext}.value.${position}.measure`;

    const getToggleTranslationName = (uniqueId: string) =>
        `${fieldContext}.value.${uniqueId}.translate`;

    return { fieldContext, valueContext, measureFieldContext, getToggleTranslationName };
}
export default getSourceFieldContent;
